import React from "react";
import { EmtPaper, EmtPaperProps } from "./EmtPaper";
import Box from "@mui/material/Box";

export type EmtInformationCardProps = EmtPaperProps & {
  /**
   * Image to the left of information card
   * @default undefined
   */
  img?: React.ReactNode;
  nonce?: string;
};

export function EmtInformationCard(props: EmtInformationCardProps) {
  const { img, children, ...rest } = props;

  return (
    <EmtPaper variant="information" {...rest} sx={{ height: "100%" }}>
      <>{img}</>
      <Box sx={{ display: "flex", flexDirection: "column" }}>{children}</Box>
    </EmtPaper>
  );
}
